var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainHeader'),_c('main',[_c('Breadcrumb',{attrs:{"page":"Contact Us"}}),_c('Contact')],1),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }